module.exports = __webpack_public_path__ + "media/icons/widget-download_app_store_black@3x-e06a6235.svg";